<template>
  <!-- v-if="dialog" -->
  <v-dialog
    v-model="deleteDialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :width="width"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="cancelAction"
  >
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>

    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{deleteTitle}}</span>
        <v-spacer></v-spacer>
        <v-btn
          text
          icon
          title="Cancelar"
          class="my-2"
          @click="cancelAction"
        >
          <v-icon right dark>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text id="dialogBody" class="mt-5 px-3 px-sm-4 px-md-6">
        <v-alert
          type="error"
          elevation="2"
          v-if="formErrors.length > 0"
          dismissible
          @input="errorsAlertClose"
          :key="alertErrorKey"
        >
          <p v-for="error in formErrors" class="mb-0">
            {{error}}
          </p>
        </v-alert>

        <slot>{{deleteText}}</slot>
        <!-- <v-container> </v-container> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-btn class="my-2" @click="cancelAction">
          {{deleteCancelButtonLabel}}
        </v-btn>

        <v-spacer></v-spacer>        

        <v-btn :color="deleteColor" class="my-2 white--text" @click="confirmAction" autofocus>
          {{deleteConfirmButtonLabel}}
          <v-icon right>{{deleteIcon}}</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    

    <template v-slot:activator="{ on: dialog }">
      <!-- delete if the canBeDeleted returns true -->
      <v-tooltip top :color="deleteColor" >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-show="showButton"
            v-on="{ ...tooltip, ...dialog }"
            class="mx-1"
            @click="openAction"
            :color="deleteColor"
          >
            {{deleteIcon}}
          </v-icon>
        </template>
        <span>{{deleteButtonLabel}}</span>
      </v-tooltip>
    </template>
    
  </v-dialog>
  <!-- <div v-else class="col">
    Em desenvolvimento!
  </div> -->
</template>

<script>

export default {
 data () {
  return {
    error: null,
    deleteDialog: false,
    alertErrorKey: 1
  }
},
props: {
  entry: Object,
  // dialog: {
  //   type: Boolean,
  //   default: true
  // },
  showButton:{
    type: Boolean,
    default: true,
  },
  formErrors: {
    type: Array,
    default: () => []
  },
  isScrollable: {
    type: Boolean,
    default: true
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  alwaysEnabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  pageLoading: {
    type: Boolean,
    default: false
  },
  modelNameSingular: {
    type: String,
    default: "Registro"
  },
  modelNamePlural: {
    type: String,
    default: "Registros"
  },
  deleteTitle: {
    type: String,
    default: function() {
      return "Deleção de " + this.modelNameSingular
    }
  },
  deleteText: {
    type: String,
    default: "Você tem certeza que deseja deletar este cadastro?"
  },
  deleteButtonLabel: {
    type: String,
    default: function() {
      return "Deletar " + this.modelNameSingular
    }
  },
  deleteCancelButtonLabel: {
    type: String,
    default: "Cancelar"
  },
  deleteConfirmButtonLabel: {
    type: String,
    default: "Deletar"
  },
  deleteIcon: {
    type: String,
    default: "mdi-printer"
  },
  deleteColor: {
    type: String,
    default: "error"
  },
  width: {
    type: String,
    default: "50%"
  },
},
watch: {
    formErrors: function(val) {
      this.alertErrorKey++;
      if (val && val.length > 0) {
        // document.getElementById('dialogBody').scrollTop = 0;
        let options = {
          container: '#dialogBody',
          duration: 300,
          offset: 0,
        }
        this.$vuetify.goTo(0, options);
      }
    }
  },
  mounted() {
    // Close modal with 'esc' key
    // document.addEventListener("keydown", (e) => {
    //   if (e.keyCode == 27) {
    //       this.cancelAction();
    //   }
    // });
  },
  methods: {
    cancelAction: function(){
      this.deleteDialog = false
      this.$emit("delete-cancel-action")
    },
    confirmAction: function(){
      this.$emit("delete-confirm-action")
    },
    openAction: function() {
      this.deleteDialog = true;
      this.$emit("delete-open-action")
    },
    closeDialog: function() {
      this.deleteDialog = false;
    },
    errorsAlertClose: function(val) {
      if (!val) {
        this.$emit("clear-form-errors");
      }
    }
  }
}
</script>

<style scoped></style>
